import React, { useState, useRef, useEffect } from 'react'
import PropTypes from 'prop-types'
import classes from './index.module.css'

export function ModalWindow({
  open,
  onClose,
  children,
  rounded = false,
  disableCloseIcon = false,
}) {
  const [isDragging, setIsDragging] = useState(false)
  const mouseDownRef = useRef(false)

  useEffect(() => {
    const handleMouseMove = () => {
      if (mouseDownRef.current) {
        setIsDragging(true)
      }
    }

    const handleMouseUp = () => {
      mouseDownRef.current = false
      setTimeout(() => setIsDragging(false), 0)
    }

    window.addEventListener('mousemove', handleMouseMove)
    window.addEventListener('mouseup', handleMouseUp)

    return () => {
      window.removeEventListener('mousemove', handleMouseMove)
      window.removeEventListener('mouseup', handleMouseUp)
    }
  }, [])

  if (!open) return null

  return (
    <div
      className={classes.backgroundContainer}
      onMouseDown={() => {
        mouseDownRef.current = true
      }}
      onClick={() => {
        if (!isDragging) {
          onClose()
        }
      }}
    >
      <div
        className={classes.container}
        style={rounded ? { borderRadius: '24px' } : {}}
        onClick={e => e.stopPropagation()}
      >
        {!disableCloseIcon && (
          <button
            className={classes.closeButton}
            onClick={() => {
              onClose()
            }}
          />
        )}

        {children}
      </div>
    </div>
  )
}

ModalWindow.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  rounded: PropTypes.bool,
  disableCloseIcon: PropTypes.bool,
}
